import React from 'react';
import Img from 'gatsby-image';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SplitImageSection = _ref => {
  let {
    heading,
    image,
    imagePosition,
    children
  } = _ref;
  return ___EmotionJSX(S.Section, {
    imagePosition: imagePosition
  }, ___EmotionJSX("div", {
    className: "int-img"
  }, ___EmotionJSX(Img, {
    fluid: image.childImageSharp.fluid,
    alt: heading
  })), ___EmotionJSX("div", {
    className: "int-text"
  }, ___EmotionJSX("h2", null, heading), children));
};
export default SplitImageSection;